import {
  errorUnlessOk,
  buildRequestWithAuth,
  headersBackendSeguros,
} from "./utils";
import environment from "~libs/environment";
import { paths, usuariosPath } from "~constants/referenceNames";
import {
  GetUsuariosResponse,
  GetUsuarioResponse,
  PostOnboardingResponse,
  Usuario,
} from "./types.js";

const mockActive = false;

const usuarios = () => {
  return {
    getUsuario: (id: string): Promise<GetUsuarioResponse> => {
      const request = buildRequestWithAuth("GET", null, headersBackendSeguros);
      const url = `${environment.segurosUrl}${paths[usuariosPath]}/${id}`;
      return fetch(url, request)
        .then(errorUnlessOk)
        .then((response) => response.json())
        .catch((error) => {
          console.error(error);
          throw error;
        });
    },
    getUsuarios: async (data: {
      skip: number;
      take: number;
      searchCriteria?: string;
      getOnlyActivos?: boolean;
    }): Promise<GetUsuariosResponse> => {
      const request = buildRequestWithAuth("GET", data, headersBackendSeguros);
      let parameters = `Skip=${data.skip}&Take=${data.take}`;

      if (data.searchCriteria) {
        parameters += `&SearchCriteria=${data.searchCriteria}`;
      }

      if (data.getOnlyActivos !== null && data.getOnlyActivos !== undefined) {
        parameters += `&GetOnlyActivos=${data.getOnlyActivos}`;
      }

      const url = `${environment.segurosUrl}${paths[usuariosPath]}?${parameters}`;

      try {
        if (mockActive) {
          return getUsuariosMock(data);
        } else {
          const response = await fetch(url, request);
          errorUnlessOk(response);
          return await response.json();
        }
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    putUsuarios: (data: {
      id: string;
      roles: string[];
      // El listado manda la actualización de activo sin oficina.
      oficinaId?: string;
      activo: boolean;
    }): Promise<Response> => {
      const request = buildRequestWithAuth("PUT", data, headersBackendSeguros);
      const url = `${environment.segurosUrl}${paths[usuariosPath]}/${data.id}`;
      return fetch(url, request)
        .then(errorUnlessOk)
        .then((response) => response)
        .catch((error) => {
          console.error(error);
          throw error;
        });
    },
    postOnboarding: (): Promise<PostOnboardingResponse> => {
      const request = buildRequestWithAuth("POST", null, headersBackendSeguros);
      const url = `${environment.segurosUrl}/onboarding`;
      return fetch(url, request)
        .then(errorUnlessOk)
        .then((response) => response.json())
        .catch((error) => {
          console.error(error);
          throw error;
        });
    },
  };
};

const getUsuariosMock = (data: {
  skip: number;
  take: number;
}): GetUsuariosResponse => {
  const usuarios: Usuario[] = [
    {
      id: "1",
      nombre: "Juan",
      email: "jdahl@mg-group.com.ar",
      oficina: "Casa Central",
      tipoUsuario: "Interno",
      roles: ["Administrador", "Emisión Manual de Pólizas", "Ver Pólizas"],
      activo: true,
    },
    {
      id: "2",
      nombre: "Juan",
      email: "jdahl@mg-group.com.ar",
      oficina: "Casa Central",
      tipoUsuario: "Interno",
      roles: [],
      activo: true,
    },
    {
      id: "3",
      nombre: "Juan",
      email: "jdahl@mg-group.com.ar",
      oficina: "Casa Central",
      tipoUsuario: "Interno",
      roles: ["Administrador", "Ver Pólizas"],
      activo: true,
    },
    {
      id: "4",
      nombre: "Juan",
      email: "jdahl@mg-group.com.ar",
      oficina: "Casa Central",
      tipoUsuario: "Interno",
      roles: ["Ver Pólizas"],
      activo: true,
    },
    {
      id: "5",
      nombre: "Juan",
      email: "jdahl@mg-group.com.ar",
      oficina: "Casa Central",
      tipoUsuario: "Interno",
      roles: ["Administrador"],
      activo: true,
    },
    {
      id: "6",
      nombre: "Juan",
      email: "jdahl@mg-group.com.ar",
      oficina: "Casa Central",
      tipoUsuario: "Interno",
      roles: ["Administrador", "Emisión Manual de Pólizas", "Ver Pólizas"],
      activo: true,
    },
    {
      id: "7",
      nombre: "Juan",
      email: "jdahl@mg-group.com.ar",
      oficina: "Casa Central",
      tipoUsuario: "Interno",
      roles: [],
      activo: true,
    },
    {
      id: "8",
      nombre: "Juan",
      email: "jdahl@mg-group.com.ar",
      oficina: "Casa Central",
      tipoUsuario: "Interno",
      roles: ["Administrador", "Ver Pólizas"],
      activo: true,
    },
    {
      id: "9",
      nombre: "Juan",
      email: "jdahl@mg-group.com.ar",
      oficina: "Casa Central",
      tipoUsuario: "Interno",
      roles: ["Ver Pólizas"],
      activo: true,
    },
    {
      id: "10",
      nombre: "Juan",
      email: "jdahl@mg-group.com.ar",
      oficina: "Casa Central",
      tipoUsuario: "Interno",
      roles: ["Administrador"],
      activo: true,
    },
    {
      id: "11",
      nombre: "Juan",
      email: "jdahl@mg-group.com.ar",
      oficina: "Casa Central",
      tipoUsuario: "Interno",
      roles: ["Administrador", "Emisión Manual de Pólizas", "Ver Pólizas"],
      activo: true,
    },
    {
      id: "12",
      nombre: "Juan",
      email: "jdahl@mg-group.com.ar",
      oficina: "Casa Central",
      tipoUsuario: "Interno",
      roles: [],
      activo: true,
    },
    {
      id: "13",
      nombre: "Juan",
      email: "jdahl@mg-group.com.ar",
      oficina: "Casa Central",
      tipoUsuario: "Interno",
      roles: ["Administrador", "Ver Pólizas"],
      activo: true,
    },
    {
      id: "14",
      nombre: "Juan",
      email: "jdahl@mg-group.com.ar",
      oficina: "Casa Central",
      tipoUsuario: "Interno",
      roles: ["Ver Pólizas"],
      activo: true,
    },
    {
      id: "15",
      nombre: "Juan",
      email: "jdahl@mg-group.com.ar",
      oficina: "Casa Central",
      tipoUsuario: "Interno",
      roles: ["Administrador"],
      activo: true,
    },
  ];

  const take = data.take;
  const page = data.skip / take;
  const filtered = usuarios.slice(page * take, page * take + take);

  return {
    usuarios: filtered,
    totalRegistros: 15,
  };
};

export { usuarios };
